exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pdfjs-viewer--component-wrapper {\n  overflow-y: scroll;\n}\n.pdfjs-viewer--component-wrapper .holder {\n    display: flex;\n    flex-direction: column;\n}\n.pdfjs-viewer--component-wrapper .holder > canvas:not(:last-child) {\n      margin-bottom: 10px;\n}\n", ""]);

// exports
